// extracted by mini-css-extract-plugin
module.exports = {"starSubIcon":"_ee1eba0"};